import React, { ChangeEvent, useContext, useState } from 'react';
import { toast } from 'react-toastify';
import { UpdateUserPassword } from '../../../../models/security/updatePassword';
import { AppContext } from '../../../../common/context/Provider';
import { UseChangeWebPageTitle, UseGetCompaniesList } from '../../../../common';
import { ssoRequests } from '../../../../services/external/APIs';
import TabHeader from '../../../../common/components/tab-seccion/TabHeader';
import TabSeccion from '../../../../common/components/tab-seccion/TabSeccion';

const ProfilePage = () => {
    const { userInfo, langResources } = useContext(AppContext);

    const { nameOfWebPage } = UseChangeWebPageTitle(
        langResources['web.pages.titles']['profile.page']
    );
    const { companies, passwordPolicies } = UseGetCompaniesList(userInfo);

    const [activeNav, setActiveNav] = useState<number>(1);
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [sendChange, setSendChange] = useState(false);
    const [changeSuccessfully, setChangeSuccessfully] = useState(false);

    const handlerChangeOldPassword = (e: ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setOldPassword(value);

        passwordPolicies.forEach((policy) => {
            if (value !== confirmPassword) {
                if (policy.title == 'differentPasswords') {
                    policy.status = true;
                }
            } else {
                if (policy.title == 'differentPasswords') {
                    policy.status = false;
                }
            }
        });

        let isCorrectPassword = passwordPolicies.map((policy) => policy.status);

        if (isCorrectPassword.includes(false)) {
            setSendChange(false);
        } else {
            setSendChange(true);
        }
    };

    const handlerChangeNewPassword = (e: ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setNewPassword(value);

        passwordPolicies.forEach((policy) => {
            if (policy.regex) {
                if (new RegExp(policy.regex).test(value)) {
                    policy.status = true;
                } else {
                    policy.status = false;
                }
            }

            if (value === confirmPassword) {
                if (policy.title === 'confirmPassword') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'confirmPassword') {
                    policy.status = false;
                }
            }

            if (value != oldPassword) {
                if (policy.title === 'differentPasswords') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'differentPasswords') {
                    policy.status = false;
                }
            }
        });

        let isCorrectPassword = passwordPolicies.map((policy) => policy.status);

        if (isCorrectPassword.includes(false)) {
            setSendChange(false);
        } else {
            setSendChange(true);
        }
    };

    const handlerChangeConfirmPassword = (e: ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setConfirmPassword(value);

        passwordPolicies.forEach((policy) => {
            if (policy.regex) {
                if (new RegExp(policy.regex).test(value)) {
                    policy.status = true;
                } else {
                    policy.status = false;
                }
            }

            if (value != oldPassword) {
                if (policy.title === 'differentPasswords') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'differentPasswords') {
                    policy.status = false;
                }
            }

            if (value === newPassword) {
                if (policy.title === 'confirmPassword') {
                    policy.status = true;
                }
            } else {
                if (policy.title === 'confirmPassword') {
                    policy.status = false;
                }
            }
        });

        let isCorrectPassword = passwordPolicies.map((policy) => policy.status);

        if (isCorrectPassword.includes(false)) {
            setSendChange(false);
        } else {
            setSendChange(true);
        }
    };

    const handlerSavepassword = () => {
        const id = toast.loading(
            langResources['profile.page']['change.password.loading']
        );

        let body: UpdateUserPassword = {
            login: userInfo.login,
            newPassword,
            oldPassword,
        };

        if (sendChange) {
            ssoRequests
                .changePassword(body)
                .then((response) => {
                    setChangeSuccessfully(true);
                    setOldPassword('');
                    setNewPassword('');
                    setConfirmPassword('');
                    toast.update(id, {
                        render: langResources['profile.page'][
                            'change.password.loading.success'
                        ],
                        type: 'success',
                        isLoading: false,
                        autoClose: 5000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        closeOnClick: true,
                        closeButton: true,
                    });
                })
                .catch((err) => {
                    console.log('Change Password', err.response.data);
                    toast.update(id, {
                        render: langResources['profile.page'][
                            'message.alert.change.password'
                        ],
                        type: 'warning',
                        isLoading: false,
                        autoClose: 5000,
                        position: toast.POSITION.BOTTOM_RIGHT,
                        closeOnClick: true,
                        closeButton: true,
                    });
                });
        } else {
            toast.error(
                langResources['profile.page']['message.failed.change.password'],
                {
                    autoClose: 5000,
                    position: toast.POSITION.BOTTOM_RIGHT,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                }
            );
        }
    };

    return (
        <div className='main-content'>
            <div className='page-content'>
                <div className='container-fluid'>
                    <div className='row mt-4'>
                        <div className='col-lg-3'>
                            <div className='card '>
                                <div className='card-body'>
                                    <div className='text-center'>
                                        <div className='profile-user position-relative d-inline-block mx-auto  mb-4'>
                                            <img
                                                src='assets/images/users/user-dummy-img.jpg'
                                                className='rounded-circle avatar-xl img-thumbnail user-profile-image'
                                                alt='user-profile'
                                            />
                                        </div>

                                        <h5
                                            className={`fs-16 mb-1 text-primary2 fw-bolder`}
                                        >
                                            {userInfo.login}
                                        </h5>
                                        <p className='text-muted mb-0'>
                                            {userInfo.email}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-9'>
                            <div className='card p-3 mb-3 card'>
                                <div className='card-header'>
                                    <ul
                                        role='tablist'
                                        id={'profile-tabs'}
                                        className='nav-tabs-custom rounded card-header-tabs border-bottom-0 nav'
                                    >
                                        <TabHeader
                                            currentActiveNav={activeNav}
                                            activeNavValue={1}
                                            setActiveNav={setActiveNav}
                                            text={
                                                langResources['profile.page'][
                                                    'personal.information.title'
                                                ]
                                            }
                                        />

                                        <TabHeader
                                            currentActiveNav={activeNav}
                                            activeNavValue={2}
                                            setActiveNav={setActiveNav}
                                            text={
                                                langResources['profile.page'][
                                                    'change.password.title'
                                                ]
                                            }
                                        />

                                        <TabHeader
                                            currentActiveNav={activeNav}
                                            activeNavValue={3}
                                            setActiveNav={setActiveNav}
                                            text={
                                                langResources['profile.page'][
                                                    'companies.associate.title'
                                                ]
                                            }
                                        />
                                    </ul>
                                </div>

                                <div className='card-body p-3'>
                                    <div className='tab-content'>
                                        <TabSeccion
                                            activeNavValue={1}
                                            currentActiveNav={activeNav}
                                        >
                                            <form className='row'>
                                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                                    <div className=''>
                                                        <label className='form-label form-label'>
                                                            {
                                                                langResources[
                                                                    'profile.page'
                                                                ][
                                                                    'personal.information.fullname'
                                                                ]
                                                            }
                                                        </label>
                                                        <input
                                                            readOnly
                                                            type='text'
                                                            className='form-control form-control text-black'
                                                            value={userInfo.fullName}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                                    <div className=''>
                                                        <label className='form-label form-label'>
                                                            {
                                                                langResources[
                                                                    'profile.page'
                                                                ][
                                                                    'personal.information.rol'
                                                                ]
                                                            }
                                                        </label>
                                                        <input
                                                            readOnly
                                                            type='text'
                                                            className='form-control form-control text-black'
                                                            value={
                                                                userInfo.role.name
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                                    <div className=''>
                                                        <label className='form-label form-label'>
                                                            {
                                                                langResources[
                                                                    'profile.page'
                                                                ][
                                                                    'personal.information.user.type'
                                                                ]
                                                            }
                                                        </label>
                                                        <input
                                                            readOnly
                                                            type='text'
                                                            className='form-control form-control text-black'
                                                            value={
                                                                userInfo.windowsUserDomain
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                                    <div className=''>
                                                        <label className='form-label form-label'>
                                                            {
                                                                langResources[
                                                                    'profile.page'
                                                                ][
                                                                    'personal.information.phone'
                                                                ]
                                                            }
                                                        </label>
                                                        <input
                                                            readOnly
                                                            type='text'
                                                            className='form-control form-control text-black'
                                                            value={
                                                                userInfo.cellphoneNumber
                                                            }
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                                    <div className=''>
                                                        <label className='form-label form-label'>
                                                            {
                                                                langResources[
                                                                    'profile.page'
                                                                ][
                                                                    'personal.information.address'
                                                                ]
                                                            }
                                                        </label>

                                                        <input
                                                            readOnly
                                                            type='text'
                                                            className='form-control form-control text-black'
                                                            value={userInfo.address}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='col-12 col-md-6 col-lg-4 mb-4'>
                                                    <div className=''>
                                                        <label className='form-label form-label '>
                                                            {
                                                                langResources[
                                                                    'profile.page'
                                                                ][
                                                                    'personal.information.user.active'
                                                                ]
                                                            }
                                                        </label>

                                                        <div
                                                            className={`mt-2 form-check form-switch text-center text-primary2 checked-custom`}
                                                        >
                                                            <input
                                                                role='switch'
                                                                name='isPaid'
                                                                defaultChecked={
                                                                    userInfo.isActive
                                                                }
                                                                type='checkbox'
                                                                className={`form-check-input form-check-input`}
                                                                readOnly
                                                                disabled
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </TabSeccion>

                                        <TabSeccion
                                            activeNavValue={2}
                                            currentActiveNav={activeNav}
                                        >
                                            <form action=''>
                                                <div className='row g-2'>
                                                    <div className='col-12 col-lg-4'>
                                                        <div>
                                                            <label
                                                                htmlFor='oldpasswordInput'
                                                                className='form-label form-label'
                                                            >
                                                                {
                                                                    langResources[
                                                                        'profile.page'
                                                                    ][
                                                                        'change.password.old.password.label'
                                                                    ]
                                                                }
                                                                *
                                                            </label>
                                                            <input
                                                                onChange={
                                                                    handlerChangeOldPassword
                                                                }
                                                                id='oldpasswordInput'
                                                                placeholder={
                                                                    langResources[
                                                                        'profile.page'
                                                                    ][
                                                                        'change.password.old.password.placeholder'
                                                                    ]
                                                                }
                                                                type='password'
                                                                className='form-control form-control'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-12 col-lg-4'>
                                                        <div>
                                                            <label
                                                                htmlFor='newpasswordInput'
                                                                className='form-label form-label'
                                                            >
                                                                {
                                                                    langResources[
                                                                        'profile.page'
                                                                    ][
                                                                        'change.password.new.password.label'
                                                                    ]
                                                                }
                                                            </label>
                                                            <input
                                                                onChange={
                                                                    handlerChangeNewPassword
                                                                }
                                                                id='newpasswordInput'
                                                                placeholder={
                                                                    langResources[
                                                                        'profile.page'
                                                                    ][
                                                                        'change.password.old.password.placeholder'
                                                                    ]
                                                                }
                                                                type='password'
                                                                className='form-control form-control'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-12 col-lg-4'>
                                                        <div>
                                                            <label
                                                                htmlFor='confirmpasswordInput'
                                                                className='form-label form-label '
                                                            >
                                                                {
                                                                    langResources[
                                                                        'profile.page'
                                                                    ][
                                                                        'change.password.confirm.password.label'
                                                                    ]
                                                                }
                                                            </label>
                                                            <input
                                                                onChange={
                                                                    handlerChangeConfirmPassword
                                                                }
                                                                id='confirmpasswordInput'
                                                                placeholder={
                                                                    langResources[
                                                                        'profile.page'
                                                                    ][
                                                                        'change.password.confirm.password.label'
                                                                    ]
                                                                }
                                                                type='password'
                                                                className='form-control form-control'
                                                                disabled={
                                                                    newPassword ===
                                                                    ''
                                                                }
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-12 pt-3'>
                                                        <div className='row'>
                                                            <div className='col-12 col-lg-8'>
                                                                {passwordPolicies.map(
                                                                    (pp, index) =>
                                                                        !pp.status && (
                                                                            <li
                                                                                className='text-danger'
                                                                                key={
                                                                                    pp.title
                                                                                }
                                                                            >
                                                                                {
                                                                                    pp.message
                                                                                }
                                                                            </li>
                                                                        )
                                                                )}

                                                                {changeSuccessfully && (
                                                                    <p className='text-success fa-4'>
                                                                        {
                                                                            langResources[
                                                                                'profile.page'
                                                                            ][
                                                                                'save.change.successfully'
                                                                            ]
                                                                        }
                                                                    </p>
                                                                )}
                                                            </div>

                                                            <div className='col-12 col-lg-4 d-flex justify-content-end align-self-end'>
                                                                <button
                                                                    style={{
                                                                        height: 40,
                                                                    }}
                                                                    type='button'
                                                                    className={`btn btn-primary`}
                                                                    disabled={
                                                                        newPassword ===
                                                                            '' ||
                                                                        oldPassword ===
                                                                            '' ||
                                                                        confirmPassword ===
                                                                            '' ||
                                                                        sendChange ===
                                                                            false
                                                                    }
                                                                    onClick={
                                                                        handlerSavepassword
                                                                    }
                                                                >
                                                                    {
                                                                        langResources[
                                                                            'profile.page'
                                                                        ][
                                                                            'btn.save.changes'
                                                                        ]
                                                                    }
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </TabSeccion>

                                        <TabSeccion
                                            activeNavValue={3}
                                            currentActiveNav={activeNav}
                                        >
                                            <div className='row'>
                                                <ul className='list-group list-group-flush'>
                                                    {companies.map((comp) => (
                                                        <li
                                                            className='list-group-item text-black '
                                                            key={comp.company.id}
                                                        >
                                                            {comp.company.name}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </TabSeccion>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
